/**
 * The signed-in user and their school memberships, and the first-login setup
 * that creates them.
 *
 * Callers decide when setup is needed from the Clerk user (not onboarded, or no
 * `externalId`); `GET /v1/users/me` no longer signals it.
 */

import { MeResponseSchema, type MeResponse } from '@school-journey/shared-types/api/users'
import type { BackendClient } from '@/lib/backend-client/client'

/** @see GET /v1/users/me */
export function getMe(client: BackendClient): Promise<MeResponse> {
  return client.request({ method: 'GET', path: '/v1/users/me' }, MeResponseSchema)
}

/**
 * Creates a brand-new user's identity and memberships from their sign-in.
 *
 * @see POST /v1/auth/setup
 */
export async function setUpNewUser(client: BackendClient): Promise<void> {
  await client.send({ method: 'POST', path: '/v1/auth/setup', body: {} })
}
